import React from 'react';
import { Helmet } from 'react-helmet';

export default function RegexSearchReplaceGuide() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>Using Regex for Search & Replace (Beginner Guide) | WebUtility</title>
        <meta name="description" content="A beginner-friendly introduction to regular expressions (regex) and how to use them for search and replace operations." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Using Regex for Search & Replace (Beginner Guide)</h1>
      <p className="mb-4 text-gray-600">
        Regular expressions (regex) can seem scary, but they allow powerful search and replace operations. Learn the basics and try it live!
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">What is Regex?</h2>
      <p>Regex is a pattern used to match character combinations in strings. For example, <code>\d+</code> matches any sequence of digits.</p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Common Regex Patterns:</h2>
      <ul className="list-disc ml-6">
        <li><code>\d+</code> - Matches any number.</li>
        <li><code>\w+</code> - Matches any word.</li>
        <li><code>[A-Za-z]</code> - Matches any letter.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Try it:</h2>
      <p><a href="/regextester" className="text-blue-600 underline">Live Regex Tester Tool</a></p>
    </main>
  );
}
